module.exports = __webpack_public_path__ + "img/Type=NL Compact, Color=White.4678b174.svg";